<template>
  <div class="p-0 pl-1 m-0" :class="{'col-12': $window.isSP, 'col-2': $window.isPC}">
    <div v-if="$window.isSP">
        <span v-if="title" class="pt-3" style="float:left;"><h3>{{title}}</h3></span>
        <button class="btn mt-2 btn-outline-dark" style="float:right;" @click.stop="clickShowMenu">
            <i class="fa fa-user"></i>ユーザ情報
        </button>
    </div>
    <transition>
            <div @click.stop v-show="($window.isPC) || showMenu" :class="{'accordion': $window.isSm || $window.isXs, 'open': showMenu}">
            <nav>
                <ul class="nav nav-pills flex-column">
                    <li class="nav-item pt-2 pb-2 mb-2 name-label">
                        <h5>{{user.userName}}</h5>
                    </li>
                </ul>
                <ul class="nav nav-pills flex-column">
                    <li class="nav-item">
                        <p class="side-label"><i class="fa fa-calendar ml-1 mr-1"></i>入社日</p>
                        <p v-if="user.hireDate">{{user.hireDate | datetime}}</p>
                        <p v-else>未設定</p>
                    </li>
                    <li class="nav-item">
                        <p class="side-label"><i class="fa fa-building ml-1 mr-1"></i>所属</p>
                        <p v-if="user.unit">{{user.unit}}</p>
                        <p v-else>未設定</p>
                    </li>
                    <li class="nav-item">
                        <p class="side-label"><i class="fa fa-clipboard ml-1 mr-1"></i>シフト</p>
                        <p v-if="user.shiftName">{{user.shiftName}}</p>
                        <p v-else>未設定</p>
                    </li>
                    <li class="nav-item">
                        <p class="side-label"><i class="fa fa-clock ml-1 mr-1"></i>{{month | monthBy2digit}}の労働時間({{user.workStartDate}}日始)</p>
                        <p><span>{{user.workHourSum}}（{{user.workCount}}日）</span></p>
                    </li>
                    <li class="nav-item">
                        <p class="side-label"><i class="fa fa-yen-sign ml-1 mr-1"></i>{{month | monthBy2digit}}の交通費</p>
                        <p><span>{{user.kotsuhiSum | separate}}</span>円</p>
                    </li>
                    <li class="nav-item">
                        <p class="side-label"><i class="fa fa-gift ml-1 mr-1"></i>有給残日数</p>
                        <p>
                            <span v-if="user.yukyuStartDate">
                              <div>{{user.yukyuReamingDays}}日(次回{{user.yukyuStartDate | next }}付与)</div>
                              <div>内訳: 
                                <div style="text-indent: 1em;">前年度残: {{ user.yukyuPreReamingDays }}日</div>
                                <div style="text-indent: 1em;">今年度残: {{ (user.yukyuReamingDays - user.yukyuPreReamingDays) }}日</div>
                              </div>
                            </span>
                            <span v-else>有給付与なし</span>
                        </p>
                    </li>
                </ul>
            </nav>
        </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.name-label {
 border-bottom: solid 3px #eceeef;
 position: relative;
}
.name-label:after {
position: absolute;
content: " ";
display: block;
border-bottom: solid 3px slategray;
bottom: -3px;
width: 20%;
}
.side-label{
 position: relative;
 padding: 0.2em;
 background: slategray;
 color: white;
 border-radius: 3px;
}
.accordion {
    box-shadow: 0px 0px 10px;
    position: absolute;
    left: -1000px;
    padding: 20px;
    background-color: rgb(255, 255, 255);
    z-index: 100;
}
.accordion.open{
    left: -15px;
    padding-right: 100px;
    border-radius: 0px 0px 60px;
}
.v-enter-active, .v-leave-active {
  transition: left 0.5s, right 0.5s;
}
.v-enter, .v-leave-to {
  opacity: 0
}
</style>

<script>
import Vue from 'vue'
import CommonAPI from '../../api/common-api'
import UserAPI from '../../api/user-api'
import moment from 'moment'
import WindowStatePlugin from '../../util/WindowStatePlugin'

Vue.use(WindowStatePlugin)

export default {
  name: 'side-menu',
  components: {
  },
  props: {
    title: {
        default() {
            return ''
        }
    },
    year: {
        default() {
            return moment().format('YYYY')
        }
    },
    month: {
        default() {
            return moment().format('M')
        }
    }
  },
  data() {
    return {
      user: {},
      showMenu: false,
    };
  },
  watch: {
    'year': function (val) {
      this.getUserInfo()
    },
    'month': function (val) {
      this.getUserInfo()
    }
  },
  mounted() {
    this.getUserInfo()
    // 画面他の部分タッチで非表示（タブレット・スマホ時）
    $(document).click(function() {　
        if((this.$window.isSm || this.$window.isXs) && this.showMenu == true){
            this.showMenu = false
        }
    }.bind(this));
  },
  methods: {
    //===============================================
    // ユーザ情報取得
    //===============================================
    async getUserInfo () {
        let params = {
            year: this.year,
            month: this.month
        }
        this.user = await UserAPI.getUserInfo(params)
    },
    //===============================================
    // ユーザ情報表示/非表示（スマホ）
    //===============================================
    clickShowMenu () {
        this.showMenu = !this.showMenu 
    },
  },
  filters: {
    datetime: function (data) {
      return moment(data).format('YYYY年MM月DD日')
    },
    month: function (data) {
      return moment(data).format('M月')
    },
    next: function (data) {
        if (!data){
            return ''
        }
        let date = moment(data).year(moment().year())
        if(date.isAfter(moment())){
        return date.format("YYYY年M月")
        } else {
        return date.add('year', 1).format("YYYY年M月")
        }
    },
    monthBy2digit: function (data) {
      return moment(data, 'MM').format('M月')
    },
    separate: function (num) {
      if(!num){
          return 0
      }
      return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/assets/js/components/operator/SideMenu.vue